export default __webpack_public_path__ + "static/media/logo4.db3bb20b.png";